import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

// Components
import BaseMenu from 'antd/lib/menu'

// Styles
import './DropdownMenuItem.scss'

export const DropdownMenuItem = ({ className, children, ...props }) => {
  // Classlist
  const classList = useMemo(() => {
    const classes = ['x-dropdown-menu-item', className]

    return classes.join(' ')
  }, [className])

  return (
    <BaseMenu.Item className={classList} {...props}>
      {children}
    </BaseMenu.Item>
  )
}

// Props
DropdownMenuItem.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
}

DropdownMenuItem.defaultProps = {
  className: '',
  children: null,
}

export default DropdownMenuItem
